module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "dedication",
      "id": "ded",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "dedf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "v",
      "id": "pv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("This book is dedicated to the memory of "), _c('span', {
    staticStyle: {
      "font-style": "normal"
    }
  }, [_vm._v("DOUGLAS MITCHELL")]), _vm._v(", much beloved and admired longtime sociology editor at the University of Chicago Press, who had an eye for good thinking and good writing.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05596d30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-becker-0006.vue
// module id = 69
// module chunks = 0